<template>
    <section class="freeTrial">
        <div class="freeTrial__container" data-aos="fade-up" data-aos-duration="1500">
            <img src="@/assets/images/freeTrial__title.png" class="freeTrial__title" alt="免費試用！" loading="lazy" />
            <h2>免費試用！</h2>
            <h3>免費領！2%水楊酸精華液</h3>
            <div class="col-12">
                <div class="dividingLine"></div>
            </div>
            <p>
                透過LINE綁定寶拉珍選官網會員<br />
                有機會免費領取！三大品牌好禮
            </p>
            <ol>
                <li>2%水楊酸精華液30ml</li>
                <li>新客再獲得250元優惠券</li>
                <li>價值$1000會員點數</li>
            </ol>
            <p>
                體驗後於FB or IG or 痞客邦app短貼文<br />
                PO文分享心得，再送近<span>$</span><span class="big">70,000</span>多重好禮<br />
                最高可獲1年份2%水楊酸精華液！<br />
            </p>
            <div class="freeTrial__link">
                <LinkBtn title="活動辦法" @click="showDialog = !showDialog; gtagEvent('', '按鈕點擊', '活動辦法')" />
            </div>
        </div>
        <Transition>
            <TheActivities v-if="showDialog" @is-show="closeDialog($event)" />
        </Transition>
    </section>
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue';
import LinkBtn from './widget/LinkBtn.vue';
import gtagEvent from '@/assets/js/gtag';

const TheActivities = defineAsyncComponent(() =>
    import('./widget/TheActivities.vue')
);

const showDialog = ref(false);

const closeDialog = close => showDialog.value = close;

</script>

<style lang="scss" scoped>
@import '@/styles/freeTrial';
</style>
